"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var useConfig_1 = __importDefault(require("../../_util/useConfig"));
var case_card_1 = __importDefault(require("../case-card"));
function CaseCustom(props) {
    var style = props.style, className = props.className, list = props.list;
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    return (react_1.default.createElement("div", { style: style, className: (0, classnames_1.default)("".concat(classPrefix, "-case-custom"), className) },
        react_1.default.createElement("ul", { className: "custom-ul" }, list.map(function (data, index) { return (react_1.default.createElement("li", { key: "case-card-".concat(index), className: "custom-item" },
            react_1.default.createElement(case_card_1.default, __assign({}, data)))); }))));
}
exports.default = CaseCustom;
//# sourceMappingURL=CaseCustom.js.map